import { render } from "./PowerupCard.vue?vue&type=template&id=54531453&scoped=true"
import script from "./PowerupCard.vue?vue&type=script&lang=js"
export * from "./PowerupCard.vue?vue&type=script&lang=js"

import "./PowerupCard.vue?vue&type=style&index=0&id=54531453&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54531453"]])

export default __exports__